export default {
  gutterIn: 'GUTTER_IN',
  gutterInOut: 'GUTTER_IN_OUT',
  noGutter: 'NO_GUTTER',
};
